/* eslint-disable */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Progress,
  Text,
  VStack,
  HStack,
  Spinner,
  Button,
  Flex
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { getTeamReport } from '../Redux/AdminReducer/action';
import { FaFileCsv, FaFileExcel, FaUsers, FaArrowRight } from "react-icons/fa";

const ManagerDashboard = () => {
  const [teamData, setTeamData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTeamReport()).then(data => {
      if (data) setTeamData(data || []);
      setLoading(false);
    });
  }, [dispatch]);

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="50vh" direction="column" gap={4}>
        <Spinner size="xl" color="blue.500" thickness="4px" />
        <Text fontSize="xs" fontWeight="700" color="gray.500" letterSpacing="0.5px">LOADING TEAM PROGRESS...</Text>
      </Flex>
    );
  }

  return (
    <Box p={{ base: 4, md: 8 }} w="full">
      <VStack align="stretch" spacing={8}>
        {/* Header Widget */}
        <Flex 
          className="glass-card"
          p={6}
          borderRadius="3xl"
          bg="rgba(255, 255, 255, 0.45)"
          border="1px solid rgba(255, 255, 255, 0.5)"
          boxShadow="var(--shadow-premium)"
          backdropFilter="blur(20px)"
          justify="space-between"
          align="center"
          flexWrap="wrap"
          gap={6}
        >
          <Box>
            <Badge colorScheme="blue" variant="subtle" px={3} py={1} borderRadius="full" fontSize="10px" fontWeight="800" mb={3} letterSpacing="0.5px">
              👥 Supervisor Control Panel
            </Badge>
            <Heading size="md" fontWeight="850" color="gray.800" letterSpacing="-0.5px">
              Team Training Progress Roster
            </Heading>
            <Text fontSize="xs" color="gray.500" mt={1}>
              Real-time overview of your direct reports and their course completions
            </Text>
          </Box>
          
          <HStack spacing={3}>
            <Button 
              leftIcon={<FaFileCsv />}
              variant="outline"
              borderColor="rgba(0,0,0,0.06)"
              bg="white"
              color="gray.700"
              borderRadius="full"
              fontSize="xs"
              fontWeight="800"
              className="hover-lift"
              h="46px"
              px={6}
              boxShadow="var(--shadow-sm)"
              onClick={() => {
                const token = JSON.parse(localStorage.getItem('user'))?.token || "";
                window.open(`${process.env.REACT_APP_API_URL}/api/reports/progress?token=${token}`, '_blank');
              }}
            >
              Export CSV
            </Button>
            <Button 
              leftIcon={<FaFileExcel />}
              className="premium-gradient hover-lift"
              color="white"
              borderRadius="full"
              fontSize="xs"
              fontWeight="800"
              h="46px"
              px={6}
              boxShadow="0 4px 15px rgba(37,99,235,0.15)"
              onClick={() => {
                const token = JSON.parse(localStorage.getItem('user'))?.token || "";
                window.open(`${process.env.REACT_APP_API_URL}/api/reports/progress-excel?token=${token}`, '_blank');
              }}
            >
              Export Excel (.xlsx)
            </Button>
          </HStack>
        </Flex>

        {/* Table Widget Container */}
        <Box 
          className="glass-card"
          borderRadius="3xl"
          bg="rgba(255, 255, 255, 0.45)"
          border="1px solid rgba(255, 255, 255, 0.5)"
          boxShadow="var(--shadow-premium)"
          backdropFilter="blur(20px)"
          overflow="hidden"
          p={4}
        >
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th fontSize="10px" fontWeight="800" color="gray.500" letterSpacing="0.5px">EMPLOYEE</Th>
                <Th fontSize="10px" fontWeight="800" color="gray.500" letterSpacing="0.5px">DEPARTMENT</Th>
                <Th fontSize="10px" fontWeight="800" color="gray.500" letterSpacing="0.5px">ACTIVE CURRICULUM</Th>
                <Th fontSize="10px" fontWeight="800" color="gray.500" letterSpacing="0.5px">COMPLIANCE METRIC</Th>
                <Th fontSize="10px" fontWeight="800" color="gray.500" letterSpacing="0.5px">STATUS</Th>
              </Tr>
            </Thead>
            <Tbody>
              {teamData.length === 0 ? (
                <Tr>
                  <Td colSpan={5} textAlign="center" py={10}>
                    <Text fontSize="xs" color="gray.400" fontStyle="italic">No team members registered yet.</Text>
                  </Td>
                </Tr>
              ) : teamData.map((member) => (
                <Tr 
                  key={member._id}
                  transition="all 0.2s"
                  _hover={{ bg: "rgba(255,255,255,0.2)" }}
                >
                  <Td borderBottom="1px solid rgba(0,0,0,0.03)">
                    <VStack align="start" spacing={0}>
                      <Text fontWeight="850" color="gray.800" fontSize="sm">{member.fullName}</Text>
                      <Text fontSize="10px" fontWeight="700" color="gray.400">{member.email}</Text>
                    </VStack>
                  </Td>
                  <Td borderBottom="1px solid rgba(0,0,0,0.03)">
                    <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2.5} fontSize="9px" fontWeight="800">
                      {member.department || "General Operations"}
                    </Badge>
                  </Td>
                  <Td borderBottom="1px solid rgba(0,0,0,0.03)">
                    {member.enrollments && member.enrollments.length > 0 ? (
                      <VStack align="start" spacing={1.5}>
                        {member.enrollments.map((en, i) => (
                          <Text key={i} fontSize="xs" fontWeight="700" color="gray.700">• {en.courseTitle}</Text>
                        ))}
                      </VStack>
                    ) : (
                      <Text fontSize="xs" fontStyle="italic" color="gray.400">No enrollments</Text>
                    )}
                  </Td>
                  <Td minW="220px" borderBottom="1px solid rgba(0,0,0,0.03)">
                    {member.enrollments && member.enrollments.length > 0 ? (
                      <VStack align="stretch" spacing={3}>
                        {member.enrollments.map((en, i) => (
                          <Box key={i}>
                            <Flex justify="space-between" mb={1} fontSize="10px" fontWeight="750" color="gray.600">
                              <Text noOfLines={1} maxW="150px">{en.courseTitle}</Text>
                              <Text>{en.progress || 0}%</Text>
                            </Flex>
                            <Progress 
                              value={en.progress || 0} 
                              size="xs" 
                              colorScheme={en.progress === 100 ? "green" : "blue"} 
                              borderRadius="full" 
                              bg="blue.50"
                            />
                          </Box>
                        ))}
                      </VStack>
                    ) : (
                      <Text fontSize="xs" color="gray.400">-</Text>
                    )}
                  </Td>
                  <Td borderBottom="1px solid rgba(0,0,0,0.03)">
                    {member.enrollments && member.enrollments.length > 0 ? (
                      <VStack align="start" spacing={2.5}>
                        {member.enrollments.map((en, i) => (
                          <Badge 
                            key={i} 
                            colorScheme={en.status === 'Completed' ? 'green' : 'orange'}
                            variant="solid"
                            borderRadius="full"
                            px={2.5}
                            py={0.5}
                            fontSize="8px"
                            fontWeight="850"
                          >
                            {en.status || "In Progress"}
                          </Badge>
                        ))}
                      </VStack>
                    ) : (
                      <Text fontSize="xs" color="gray.400">-</Text>
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </VStack>
    </Box>
  );
};

export default ManagerDashboard;
